<template>
  <div>
    <div class="l-container">
      <p></p>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  methods: {
    // getFamilyfiles (id) {
    //   this.$store.dispatch('getFamilyfiles', id)
    // },

    // getFamilies (id) {
    //   this.$store.dispatch('getFamiliesLimit10', id)
    // }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // vm.getFamilyfiles(to.params.id)
      // vm.getFamilies(to.params.id)
    })
  },
  route: {
  }
}
</script>



// WEBPACK FOOTER //
// Familyfiles.vue?4c13df62